import { cn } from '~/lib/utils';

interface ImagePlaceholderProps {
  width: number;
  height: number;
  className?: string;
}

export function ImagePlaceholder({ width, height, className }: ImagePlaceholderProps) {
  return (
    <svg 
      width={width} 
      height={height} 
      viewBox={`0 0 ${width} ${height}`} 
      version="1.1" 
      xmlns="http://www.w3.org/2000/svg"
      className={cn(className)}
    >
      <defs>
        <linearGradient id="g" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#f3f4f6" stopOpacity="1">
            <animate 
              attributeName="stop-color" 
              values="#f3f4f6;#e5e7eb;#f3f4f6" 
              dur="2s" 
              repeatCount="indefinite"
            />
          </stop>
          <stop offset="100%" stopColor="#e5e7eb" stopOpacity="1">
            <animate 
              attributeName="stop-color" 
              values="#e5e7eb;#f3f4f6;#e5e7eb" 
              dur="2s" 
              repeatCount="indefinite"
            />
          </stop>
        </linearGradient>
      </defs>
      <rect width="100%" height="100%" fill="url(#g)" />
    </svg>
  );
}
